'use client';
import { useQuery } from '@tanstack/react-query';

import { getEarnings } from '@/services';

/**
 * useEarnings: Fetches markets/events tagged as 'earnings'.
 * Uses a long staleTime as this data doesn't change frequently within a session.
 */
export const useEarnings = () => {
  return useQuery({
    queryKey: ['earnings'],
    queryFn: async () => {
      return getEarnings();
    },
    staleTime: 60000,
    gcTime: 5 * 60 * 1000,
  });
};
